import React from "react";
import { Card, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Button, Flex, Rate, Skeleton, Typography } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";
import cogoToast from "cogo-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import { addCart } from "../../network/cart";
import useGetUserData from "../../hooks/useGetUserData";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const { Text } = Typography;

const HomeProductCard = ({ product, isLoading }) => {
  const { user } = useGetUserData();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const onAddCart = useMutation({
    mutationFn: (formData) => addCart(formData),
    onSuccess: (data) => {
      if (data.status === true) {
        cogoToast.success(t("messages.itemAddedSuccessfully"), { position: "top-right" });
        queryClient.invalidateQueries([queryKeys.listCart]);
      } else {
        cogoToast.warn(t("messages.warningOccurred"), { position: "top-right" });
      }
    },
  });

  const addToCart = () => {
    if (!localStorage.getItem("token")) {
      cogoToast.warn("Please login first to add items.", { position: "top-right" });
      return;
    }

    const formData = new FormData();
    formData.append("quantity", 1);
    formData.append("item_id", product.id);
    formData.append("user_id", user.id);
    formData.append("is_product", 1);
    onAddCart.mutate(formData);
  };

  return (
    <Container>
      <Card
        className={`card-products py-3 px-3 border ${i18next.language === "ar" ? "text-right" : ""}`}
      >
        <Link className="custom-links" to={`/productdetails/${product?.id}`} style={{ textDecoration: "none" }}>
          <Container>
            {isLoading ? (
              <Skeleton.Image style={{ width: "100%", height: 200 }} />
            ) : (
              <Card.Img
                className="lazyload"
                src={product.image}
                alt={product.name}
                loading="lazy"
              />
            )}
          </Container>
        </Link>
        <Card.Body className="px-0 pt-2 pb-0 px-2">
          <span className="card-product-name">
            {isLoading ? <Skeleton.Input active size="small" /> : <p>{product.name.length > 20 ? product.name.substring(0, 17) + "..." : product.name}</p>}
          </span>

          {isLoading ? <Skeleton active size="small" /> : <Rate disabled defaultValue={product.average_rating} />}

          <Flex justify="space-between" className="mt-3">
            {isLoading ? (
              <Skeleton.Input active size="small" style={{ width: 80 }} />
            ) : (
              <div>
                {product.new_price ? (
                  <Flex justify="space-evenly">
                    <Text className="mx-2">{product.currency}{product.new_price}</Text>
                    <Text delete type="secondary">{product.currency}{product.price}</Text>
                  </Flex>
                ) : (
                  <Text className="mx-2">{product.currency}{product.price}</Text>
                )}
              </div>
            )}

            {isLoading ? (
              <Skeleton.Button active size="small" />
            ) : (
              <Button type="primary" onClick={addToCart} icon={<ShoppingCartOutlined />} size="lg" />
            )}
          </Flex>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default HomeProductCard;
